import {
    transformAppInit, getConfigGatewayUrl
} from '../../../../../../../app';
import { createFetchAction } from '../../../../../../../middleware';
import { USER_PROFILE_MODAL_NAME } from './user-profile-modal.reducer';

export const fetchUpdateProfileRequest = (body: string) => {
    return createFetchAction({
        name: USER_PROFILE_MODAL_NAME,
        body,
        method: 'PUT',
        resolveUrl: getConfigGatewayUrl({
            key: 'UserPortalGateway',
            basePath: '/api/v1/UserProfile'
        }),
        transformInit: transformAppInit
    });
};

export const updateProfileImage = (body: string) => {
    return createFetchAction({
        name: USER_PROFILE_MODAL_NAME,
        body,
        method: 'PATCH',
        resolveUrl: getConfigGatewayUrl({
            key: 'UserPortalGateway',
            basePath: '/api/v1/UserProfile/image'
        }),
        transformInit: transformAppInit
    });
};
